.sellalong-cta-link {
  display: block;
  text-decoration: none;
}

.sellalong-cta-action {
  text-decoration: none;
  white-space: nowrap;
}
